import Api from 'src/api/Base'

class GetAvailablePsa extends Api {
  requestUrl = `/api/psa/available/${this.getParams().storeNumber}`
}

export default GetAvailablePsa
